export default function LoadingLayout() {
	return (
		<div className="ui:animate-pulse">
			<div className="ui:space-y-2 ui:mt-4">
				<div className="ui:h-8 ui:w-[400px] ui:bg-gray-100 ui:rounded-xl"></div>
				<div className="ui:h-6 ui:w-[250px] ui:bg-gray-100 ui:rounded-xl"></div>
			</div>
			<div className="ui:flex ui:gap-8 ui:mt-8">
				<div className="ui:hidden ui:lg:block ui:w-1/4">
					<div className="ui:h-12 ui:w-full ui:bg-gray-100 ui:rounded-xl"></div>
					<div className="ui:p-3 ui:space-y-3">
						<div className="ui:flex ui:items-center ui:space-x-3">
							<div className="ui:size-6 ui:bg-gray-100 ui:rounded"></div>
							<div className="ui:h-4 ui:w-3/5 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:items-center ui:space-x-3">
							<div className="ui:size-6 ui:bg-gray-100 ui:rounded"></div>
							<div className="ui:h-4 ui:w-3/5 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:items-center ui:space-x-3">
							<div className="ui:size-6 ui:bg-gray-100 ui:rounded"></div>
							<div className="ui:h-4 ui:w-3/5 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:items-center ui:space-x-3">
							<div className="ui:size-6 ui:bg-gray-100 ui:rounded"></div>
							<div className="ui:h-4 ui:w-3/5 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:items-center ui:space-x-3">
							<div className="ui:size-6 ui:bg-gray-100 ui:rounded"></div>
							<div className="ui:h-4 ui:w-3/5 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
					</div>
				</div>
				<div className="ui:flex-1 ui:space-y-6">
					<div className="ui:flex ui:space-x-4 ui:items-center">
						<div className="ui:h-12 ui:w-full ui:bg-gray-200 ui:rounded-xl"></div>
						<div className="ui:h-12 ui:hidden ui:lg:block ui:w-32 ui:bg-gray-300 ui:rounded-xl"></div>
					</div>
					<div className="ui:flex ui:-mt-4 ui:flex-col">
						<div className="ui:h-3 ui:w-[250px] mt-0 ui:bg-gray-200 ui:rounded-xl"></div>
						<div className="ui:h-5 ui:w-[150px] ui:mt-6  ui:bg-gray-200 ui:rounded-xl"></div>
					</div>
					<div className="ui:space-y-4 ui:mt-2">
						<div className="ui:flex ui:gap-4 ui:border-b ui:flex-col ui:border-gray-100 ui:border-t ui:pt-4 ui:pb-4">
							<div className="ui:h-4 ui:w-1/2 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:gap-4 ui:border-b ui:flex-col ui:border-gray-100 ui:pb-4">
							<div className="ui:h-4 ui:w-1/2 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:gap-4 ui:border-b ui:flex-col ui:border-gray-100 ui:pb-4">
							<div className="ui:h-4 ui:w-1/2 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:gap-4 ui:border-b ui:flex-col ui:border-gray-100 ui:pb-4">
							<div className="ui:h-4 ui:w-1/2 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
						<div className="ui:flex ui:gap-4 ui:border-b ui:flex-col ui:border-gray-100 ui:pb-4">
							<div className="ui:h-4 ui:w-1/2 ui:bg-gray-200 ui:rounded-xl"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
